import React, { Fragment } from "react";
import { Helmet } from "react-helmet";

export default function PrerenderMeta({
    isLoading
}) {
    if(isLoading) {
        return <Fragment />
    }
    return (
        <Helmet>
            <meta name="prerender" content="done"/>
        </Helmet>
    )
}